module.exports = __webpack_public_path__ + "static/media/taskify.a890b00c.svg";